import backendServices from '@department-of-veterans-affairs/platform-user/profile/backendServices';
import {
  isLoggedIn,
  isLOA3,
  isProfileLoading,
  isVAPatient,
} from 'platform/user/selectors';
import baseConfig from './config/base';

export const selectIsEnrolledInVAHealthCare = state => isVAPatient(state);

export const selectOnboardingModal = state => state.onboardingModal;

export const selectOnboardingShow = state => state.onboardingModal?.show;

export const selectShouldShowOnboarding = state =>
  selectOnboardingShow(state) === true;

export const selectOnboardingAuthState = state => ({
  isOnboardingModalEnabled: state.featureToggles?.cve_onboarding_modal,
  isOnboardingModalDismissed: !!state.onboardingModal?.dismissed,
});

export const selectCanAccessClaims = state =>
  state.user?.profile?.services?.includes(backendServices.LIGHTHOUSE);

export const selectActiveModal = (
  state,
  config = baseConfig,
  path = document.location.pathname,
) => {
  const { onboardingModal } = state;

  if (!onboardingModal?.isInitialized || isProfileLoading(state)) return null;

  const loggedIn = isLoggedIn(state);
  const loa3 = isLOA3(state);
  const isPasskeyLogin =
    state.user?.profile?.signIn?.serviceName === 'webauthn';

  if (
    config.disabled ||
    (config.featureFlag && !state.featureToggles?.[config.featureFlag]) ||
    !config.paths.test(path) ||
    (config.requiresAuth && !loggedIn) ||
    (config.requiresLOA3 && !loa3) ||
    isPasskeyLogin ||
    !selectShouldShowOnboarding(state) ||
    onboardingModal.dismissed
  ) {
    return null;
  }

  return config;
};
